if (!('loading' in HTMLImageElement.prototype)) {
  import('lazysizes')
}
